Object.assign(window.labelToSkuPartMap = window.labelToSkuPartMap || {}, {
  "BARON": "B",
  "BARONESS": "BF",
  "DUCHESS": "DF",
  "DUKE": "D",
  "VISCOUNT": "V",
  "VISCOUNTESS": "VF",
  "COUNT": "C",
  "COUNTESS": "CF",
  "MARQUIS": "M",
  "MARQUISE": "MF",
  "LE BARON, GATINEAU": "GAT",
  "BARON & BARONESS": "BF",
  "DUKE & DUCHESS": "DF",
  "VISCOUNT & VISCOUNTESS": "VF",
  "COUNT & COUNTESS": "CF",
  "MARQUIS & MARQUISE": "MF"
});